export default __webpack_public_path__ + "static/media/project-name-blue.83e5aa9f.png";